export default __webpack_public_path__ + "static/01_cover@2x-45ccfc40479f1bc1c2ac27a3bfe0872d.jpg";